import { BookOpen, GraduationCap, Clock, UserCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const benefits = [{
  title: "Metodología Práctica",
  description: "Fundamenta tu conocimiento con una base sólida y el rigor académico de la enseñanza tradicional",
  icon: BookOpen
}, {
  title: "Profesores Expertos",
  description: "Fórmate con profesionales titulados en activo que conocen las demandas de cada alumno.",
  icon: GraduationCap
}, {
  title: "Flexibilidad Total",
  description: "Adapta el ritmo de estudio a tus necesidades con acceso continuo a los materiales.",
  icon: Clock
}, {
  title: "Atención Personalizada",
  description: "Grupos reducidos e individuales para garantizar tu éxito académico.",
  icon: UserCheck
}];
export default function AcademyBenefits() {
  return <section id="academybenefits" className="py-20 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">Ventajas</h2>
          <p className="text-lg text-muted-foreground font-sans">
            Descubre por qué somos la mejor opción para impulsar tu futuro con una formación diseñada para el éxito.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="bg-card border border-border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-default text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground font-sans leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}